import Modifier from 'ember-modifier';

export default class DidInsertUpdateModifier extends Modifier {
  modify(element, [callback, ...args]) {
    callback?.(element, args);
  }
}
